module.exports = __webpack_public_path__ + "static/banner13-25b9639e769147dcbded3cb9667f65ad.jpeg";